// Packages
//import { useSelector } from 'react-redux';

// Component
import { useEffect, useState } from "react";
import HomeComponent from "../../component/web/Home/home";
import {
  setInToLocalStorage,
  getFromLocalStorage,
} from "../../utils/webStorage";

import { tokenGenerator } from "../../Common/tokenGenerator";
import userService from "../../services/user.service";

function Index() {
  useEffect(() => {
    const token = tokenGenerator();
    const isTokenExist = getFromLocalStorage("Contendzone-Token");
    if (isTokenExist == null) {
      const data = userService.addWebsiteVisitor(token);
      data
        .then((res) => {
          setInToLocalStorage("Contendzone-Token", token);
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }, []);
  return (
    <div>
      <HomeComponent />
    </div>
  );
}

export default Index;
